import React from "react";
import { Link2, X, Check } from "lucide-react";

// Găsește expresia în textul editorului și o îmbracă într-un <a>; altfel adaugă propoziția la final.
export const applyInternalLink = (root, suggestion) => {
  const href = `/post/${encodeURIComponent(suggestion.slug)}`;
  const phrase = (suggestion.anchor_text || "").trim();
  if (phrase) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest("a")) continue;
      const idx = node.textContent.toLowerCase().indexOf(phrase.toLowerCase());
      if (idx === -1) continue;
      const range = document.createRange();
      range.setStart(node, idx);
      range.setEnd(node, idx + phrase.length);
      const a = document.createElement("a");
      a.href = href;
      range.surroundContents(a);
      return "wrapped";
    }
  }
  const sentence = suggestion.sentence?.includes("{LINK}")
    ? suggestion.sentence
    : `Am mai scris despre asta în {LINK}.`;
  const p = document.createElement("p");
  const [before, after] = sentence.split("{LINK}");
  p.append(before);
  const a = document.createElement("a");
  a.href = href;
  a.textContent = suggestion.title;
  p.appendChild(a);
  p.append(after || "");
  root.appendChild(p);
  return "appended";
};

export const InternalLinkSuggestions = ({ suggestions, onInsert, onClose }) => (
  <div
    data-testid="internal-links-panel"
    className="rounded-2xl border border-[color-mix(in_srgb,var(--teal)_35%,transparent)] bg-[color-mix(in_srgb,var(--tint-mint)_60%,white)] p-4"
  >
    <div className="flex items-start justify-between gap-3">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-[var(--teal-dark)]">Legături interne propuse</p>
        <p className="mt-1 text-xs text-[#F7F1E8]/78">
          Însemnări mai vechi pe aceeași temă. Apasă „Inserează” și linkul intră firesc în text.
        </p>
      </div>
      <button
        type="button"
        onClick={onClose}
        aria-label="Închide"
        data-testid="internal-links-close"
        className="rounded-full p-1 text-[#F7F1E8]/68 hover:bg-[#2B1B13] hover:text-[#F7F1E8]"
      >
        <X className="h-4 w-4" strokeWidth={1.8} />
      </button>
    </div>
    {suggestions.length === 0 ? (
      <p data-testid="internal-links-empty" className="mt-3 text-sm text-[#F7F1E8]/86">
        Nu am găsit însemnări vechi care să se lege firesc de textul acesta.
      </p>
    ) : (
      <ul className="mt-3 space-y-2">
        {suggestions.map((s, i) => (
          <li
            key={s.slug}
            data-testid={`internal-link-item-${i}`}
            className="flex flex-wrap items-center justify-between gap-3 rounded-xl bg-[#2B1B13]/80 px-3.5 py-2.5"
          >
            <div className="min-w-0 flex-1">
              <p className="flex items-center gap-1.5 font-serif text-[15px] text-[var(--milk)]">
                <Link2 className="h-3.5 w-3.5 shrink-0" strokeWidth={1.8} />
                <span className="truncate">{s.title}</span>
              </p>
              {s.anchor_text && (
                <p className="mt-0.5 text-xs text-[#F7F1E8]/78">
                  pe expresia: <em>„{s.anchor_text}”</em>
                </p>
              )}
              {s.reason && <p className="mt-0.5 text-xs text-[#F7F1E8]/68">{s.reason}</p>}
            </div>
            {s.inserted ? (
              <span className="inline-flex items-center gap-1 text-xs font-medium text-[var(--teal-dark)]">
                <Check className="h-3.5 w-3.5" strokeWidth={2} /> Inserat
              </span>
            ) : (
              <button
                type="button"
                data-testid={`internal-link-insert-${i}`}
                onClick={() => onInsert(i)}
                className="rounded-full bg-[var(--teal)] px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.12em] text-white transition-transform hover:-translate-y-0.5 active:scale-95"
              >
                Inserează
              </button>
            )}
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default InternalLinkSuggestions;
